

















import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../store/edit';

export default Vue.extend({
	name: 'ZakladniInformace',
	props: {
		storeUri: { type: String, required: true },
	},
	computed: {
		...genVuexComputeds(store),
	},
});
